export const businessModelMenu = [
  {
    id: 6,
    link: "#we-leverage-our-expertise",
    label: "We leverage our expertise",
  },
  {
    id: 1,
    link: "#to-create-a-platform-for-growth",
    label: "To Create a platform to growth",
  },
  {
    id: 2,
    link: "#driven-by-our-sustainable-business-strategy",
    label: "Driven by our sustainable business strategy",
  },
  // {
  //   id: 3,
  //   link: "#to-deliver-value-to-our-stakeholders",
  //   label: "To deliver value to our stakeholder",
  // },
];
